import { Injectable } from '@angular/core';
import { TraceAction } from '@modules/business-accounts/utils/enums/trace-actions.enum';
import { TraceError } from '@modules/business-accounts/utils/enums/trace-erros.enum';
import { IEventDescriptor } from '@modules/business-accounts/utils/interfaces/trace.interface';

@Injectable({
    providedIn: 'root'
})
export class TraceService  {

  private _frameRef?: HTMLIFrameElement;
  private _commonInfo: object = {};
  private _frameReady!: Promise<boolean>;

  setFrameRef(ref: HTMLIFrameElement): void {
    this._frameRef = ref;
    this._frameReady = new Promise(resolve => {
      this._frameRef!.onload = () => resolve(true);
    });
  }

  setCommonInfo(info: object, replace?: boolean): void {
    this._commonInfo = replace ? info : {
      ...this._commonInfo,
      ...info,
    };
  }

  async registerEvent(eventDescriptor: IEventDescriptor, info: object = {}) {
    await this._frameReady;
    this._frameRef?.contentWindow?.postMessage(JSON.stringify({
      type: TraceAction.PAGE_EVENT,
      payload: {
        name: eventDescriptor.eventName,
        info: {
          ...this._commonInfo,
          ...info,
          eType: eventDescriptor.eventType,
        },
      },
    }), '*');
  }

  async registerError(error: TraceError, info?: object) {
    await this._frameReady;

    let mappedInfo = info;

    // if (isHttpError<AxiosError>(info, 'isAxiosError')) {
    //   mappedInfo = {
    //     code: info.code,
    //     method: info.config.method,
    //     url: info.config.url,
    //     baseURL: info.config.baseURL,
    //     response: info.response?.data,
    //     headers: info.config.headers,
    //   };
    // } else if (isHttpResponse<AxiosResponse>(info, 'data', () => !(info as any)?.response)) {
    //   mappedInfo = {
    //     code: info.status,
    //     method: info.config.method,
    //     url: info.config.url,
    //     baseURL: info.config.baseURL,
    //     response: info.data,
    //     headers: info.config.headers,
    //   };
    // }

    this._frameRef?.contentWindow?.postMessage(JSON.stringify({
      type: TraceAction.ERROR,
      payload: {
        error,
        info: {
          ...this._commonInfo,
          ...mappedInfo,
        },
      },
    }), '*');
  }
}